import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Tab = styled.li<{ isActive: boolean }>`
  ${({ theme, isActive }) => css`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 38px;
    padding: 8px;
    transition: border 0.3s ease-in-out;
    border-bottom: 2px solid
      ${isActive
        ? theme.content.content_light_1
        : theme.content.content_light_5};

    span {
      ${theme.fontStyle.text.body16_medium}
      transition: color 0.3s ease-in-out;
      color: ${isActive
        ? theme.content.content_light_1
        : theme.content.content_light_5};
    }
  `}
`;
